<script setup lang="ts">
import type { ResolvedSelfSellInModel } from '../../composables/useSelfSellIn';
import SectionContainer from './../SectionContainer.vue';
import SectionHeader from './../SectionHeader.vue';
import VideoCarousel from './VideoCarousel.vue';

defineProps<{
  data: NonNullable<ResolvedSelfSellInModel['seasonNewsSection']>;
}>();
</script>

<template>
  <SectionContainer :section-title="data.title">
    <SectionHeader :title="data.title" :description="data.description" />
    <VideoCarousel :slides="data.slides" />
  </SectionContainer>
</template>
